module.exports = require('./helpers/bundle-url').getBundleURL('f1MDn') + "logo-dark.eefe0b7f.svg";